import { render, staticRenderFns } from "./FinePrint.vue?vue&type=template&id=754cef0e&"
import script from "./FinePrint.vue?vue&type=script&lang=ts&"
export * from "./FinePrint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports